import React from 'react';
import styles from './ReportSectionSelectOptionItem.module.scss';

export interface ReportSectionSelectOptionItemProps {
  title: string;
  subTitle: string;
}

export const ReportSectionSelectOptionItem = ({
  title,
  subTitle
}: ReportSectionSelectOptionItemProps): React.ReactElement<ReportSectionSelectOptionItemProps> => {
  return (
    <div>
      <div className={styles.reportSectionSelectOptionItem}>
        <div className={styles.content}>
          <p className={styles.title}>{title}</p>
          <p className={styles.subTitle}>{subTitle}</p>
        </div>
      </div>
    </div>
  );
};
